import { createAction, props } from '@ngrx/store';
import { PolicySchemaResult } from '../models/policy-schema.model';
import {
  PolicyListItem,
  GetPoliciesQuery,
  PolicyFilterStatus,
  PolicyOrderBy,
  PolicyOrder,
} from '../models/policy-list.model';

/**
 * Policy Schema Actions
 */
export const loadPolicySchema = createAction(
  '[Create Policy] Load Policy Schema'
);

export const loadPolicySchemaSuccess = createAction(
  '[Create Policy] Load Policy Schema Success',
  props<{ schema: PolicySchemaResult }>()
);

export const loadPolicySchemaFailure = createAction(
  '[Create Policy] Load Policy Schema Failure',
  props<{ error: string }>()
);

/**
 * Policy Form Actions
 */
export const updateDomain = createAction(
  '[Create Policy] Update Domain',
  props<{ domain: string | null }>()
);

export const updateResource = createAction(
  '[Create Policy] Update Resource',
  props<{ resource: string | null }>()
);

export const updateAction = createAction(
  '[Create Policy] Update Action',
  props<{ action: string | null }>()
);

export const updateScope = createAction(
  '[Create Policy] Update Scope',
  props<{ scope: string | null }>()
);

export const resetForm = createAction('[Create Policy] Reset Form');

export const submitPolicy = createAction(
  '[Create Policy] Submit Policy',
  props<{ payload: any }>()
);

export const submitPolicySuccess = createAction(
  '[Create Policy] Submit Policy Success',
  props<{ response: any }>()
);

export const submitPolicyFailure = createAction(
  '[Create Policy] Submit Policy Failure',
  props<{ error: string }>()
);

/**
 * User Actions
 */
export const loadUsers = createAction('[Create Policy] Load Users');

export const loadUsersSuccess = createAction(
  '[Create Policy] Load Users Success',
  props<{ users: any }>()
);

export const loadUsersFailure = createAction(
  '[Create Policy] Load Users Failure',
  props<{ error: string }>()
);

/**
 * Policy List Actions
 */
export const loadPolicies = createAction(
  '[Policy] Load Policies',
  props<{ query?: GetPoliciesQuery }>()
);

export const loadPoliciesSuccess = createAction(
  '[Policy] Load Policies Success',
  props<{
    policies: PolicyListItem[];
    pagination: {
      page: number;
      limit: number;
      total: number;
      totalPages: number;
    };
  }>()
);

export const loadPoliciesFailure = createAction(
  '[Policy] Load Policies Failure',
  props<{ error: string }>()
);

export const setPage = createAction(
  '[Policy] Set Page',
  props<{ page: number }>()
);

export const setPageSize = createAction(
  '[Policy] Set Page Size',
  props<{ pageSize: number }>()
);

export const setStatusFilter = createAction(
  '[Policy] Set Status Filter',
  props<{ status: PolicyFilterStatus }>()
);

export const setDomainFilter = createAction(
  '[Policy] Set Domain Filter',
  props<{ domain: string | null }>()
);

export const setSort = createAction(
  '[Policy] Set Sort',
  props<{ sortBy: PolicyOrderBy; sortType: PolicyOrder }>()
);

export const resetFilters = createAction('[Policy] Reset Filters');
